import { AdminPageHeader } from '@/components/patterns/admin-page'
import AddOnSetForm from '@/components/forms/AddOnSetForm'
import { adminRouteTitleHead } from '@/lib/admin-route-title'
import { addOnSetQueries, useAddOnSet } from '@/lib/services/add-on-sets/addOnSets.query'
import { addOnSetParamsSchema } from '@/lib/services/add-on-sets/addOnSets.schema'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { PackagePlus } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/$orgId/products/add-on-sets/$addOnSetId')({
  component: AddOnSetDetailPage,
  head: adminRouteTitleHead,
  params: {
    parse: (params) => addOnSetParamsSchema.parse(params),
  },
  loader: async ({ context, params }) => {
    if (!context.ability.can('view', 'products')) throw notFound()

    const addOnSet = await context.queryClient.ensureQueryData(
      addOnSetQueries.show({ organizationId: params.orgId, addOnSetId: params.addOnSetId })
    )

    return { addOnSet, isReadOnly: !context.ability.can('edit', 'products') }
  },
})

export function AddOnSetDetailPage() {
  const { addOnSetId } = Route.useParams()
  const { data: addOnSet } = useAddOnSet(addOnSetId)

  return (
    <div className="space-y-4">
      <AdminPageHeader icon={PackagePlus} title={addOnSet.name} />
      <AddOnSetForm initialData={addOnSet} organizationId={addOnSet.organization_id} />
    </div>
  )
}
